export class Client_Info {
   constructor(descuento, negocio_especial){
      this.descuento = descuento
      this.negocio_especial = negocio_especial
   }
   static fromServiceClienteInfo (client_info) {
      return new Client_Info(
         client_info.descuento,
         client_info.negocio_especial
         );
   }   
}